<template>
    <div>
        <ValidationProvider :rules="required ? 'required' : ''" v-slot="{ errors }">
            <label :for="inputRef">{{ label }}</label>
            <input
                :ref="inputRef"
                :value="value"
                :type="type"
                :placeholder="placeholder"
                autocomplete="off"
                class="input-secondary-light"
                :class="{ 'form-control is-invalid': errors && errors.length }"
                @keydown.enter.prevent
                @input="$emit('input', $event.target.value)"
                @keyup.enter="$emit('keyup', $event.target.value)"
            />
            <span class="required small text-danger" v-if="required && errors[0]">&nbsp;&nbsp;&nbsp;{{ errors[0] }}</span>
        </ValidationProvider>
    </div>
</template>
  
<script>
export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        value: String,
        type: {
            type: String,
            default: 'text'
        },
        placeholder: {
            type: String,
            default: ''
        },
        inputRef: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    computed: {}
};
</script>
  